<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog
            v-model="dialog"
            persistent
            width="550"
            content-class="pt-16 border-radius-3 elevation-0"
            hide-overlay
        >
            <v-card
                class="border-radius-3 pa-5 position-relative d-flex justify-center flex-column elevation-6"
                color="#e9f5f4"
            >
                <div class="position-absolute bee-6">
                    <img :src="bee_6" class="big-bee" />
                </div>
                <v-row>
                    <v-col>
                        <v-card-title class=" d-flex justify-center"
                            ><span
                                class="titles text-h4 font-weight-medium primary--text py-3 d-flex justify-center"
                                >{{ greetWelcomeMessage }}</span
                            ></v-card-title
                        >
                        <v-card-text class=""
                            ><span class="primary--text text-h6">{{
                                $t('initialTour.finish_onboarding')
                            }}</span></v-card-text
                        >
                    </v-col>
                </v-row>

                <v-card-actions class="d-flex justify-center">
                    <v-btn data-cy="finishOnboarding-finish-button" color="secondary px-15" large rounded @click="nextPass">{{
                        $t('initialTour.get_started')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable global-require */

import { mapState, mapActions } from 'vuex'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
        }),
        greetWelcomeMessage() {
            // eslint-disable-next-line no-nested-ternary
            return `${this.$t('initialTour.excellent')} ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
    },
    data() {
        return {
            bee_6: require('@/assets/img/bees/bee006.svg'),
        }
    },
    methods: {
        ...mapActions('dashboard', ['showFinishOnBoardingModal']),
        nextPass() {
            this.showFinishOnBoardingModal()
        },
    },
}
</script>
<style>

.avatar-stars {
    background: url(../../assets/img/effects/avatar-stars.svg) round;
}

.bee-6 {
    top: -8vh;
    right: 25%;
}
.big-bee {
    width: 35vh;
}
</style>
